<template>
  <div class="applicationList">
    <!--顶部导航-->
    <Navbar title="借款用途" />
    <!--内容区域-->
    <div class="content">
      <!--用途列表-->
      <div v-for="item in applicationList" :key="item.id">
        <applicationListField :itemData="item" />
      </div>
      <div class="footer-wrap">
        确定
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import { applicationList } from "@/utils/const.js";
import applicationListField from "@/components/applicationList/applicationListField.vue";

export default {
  name: "ApplicationList",
  components: {
    Navbar,
    applicationListField,
  },
  data() {
    return {
      applicationList,
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.applicationList {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f4f4;
  background-image: url("@/assets/style/order-bg.png");
  background-size: 100% 50%;
  background-repeat: no-repeat;
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
.content {
  padding: 0px 16px;
}
.footer-wrap {
  margin-top: 40px;
  background: #01ABFF;
  border-radius: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: "Regular";
  color: #fff;
}
</style>
